<template>
    <form id="mainForm" action="#" method="post">
        <TabView class="custom-tabview">  
            <TabPanel :header="$t('Main_Data')">
                <Card>
                    <template #title>
                        <Toolbar>
                            <template #left>
                                <div class="p-card-title">
                                    [{{ mode }}] {{ $t('maindata') }}
                                </div>
                                <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                                    <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                        aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                                    <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                        style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                        <div class="grid field">
                                            <div class="row">
                                                <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                            </div>
                                            <div class="row">
                                                &nbsp;by {{ header.Created_By }}
                                            </div>
                                        </div>
                                        <div class="grid field" v-if="header.Edited_Date">
                                            <div class="row">
                                                <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                            </div>
                                            <div class="row">
                                                &nbsp;by {{ header.Edited_By }}
                                            </div>
                                        </div>
                                        <div class="grid field" v-if="header.Deleted_Date">
                                            <div class="row">
                                                <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                            </div>
                                            <div class="row">
                                                &nbsp;by {{ header.Deleted_By }}
                                            </div>
                                        </div>
                                    </OverlayPanel>
                                </div>
                            </template>

                            <template #right>
                                <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                                <!-- <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="(header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)"/> -->
                                <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL" />
                                <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                                    v-if="mode == this.$FORM_MODE_DELETE" />
                                <ConfirmPopup></ConfirmPopup>
                            </template>
                        </Toolbar>
                    </template>
                    <template #content>
                        <div class="p-inputtext-sm p-fluid">
                            <div class="grid">
                                <div class="col-6">
                                    
                                    <FormField :labelName="$t('is_urgent_main_data')" fieldName="Is_Urgent" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <Checkbox name="Is_Urgent" v-model="header.Is_Urgent" :binary="true" v-if="header"
                                                :disabled="mode != this.$FORM_MODE_CREATE"
                                                @change="onClickIsUrgent();onChange()"/>
                                            <Skeleton v-else-if="!header" />
                                    </FormField>

                                    <FormField :labelName="$t('work')" fieldName="Is_Work" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <Checkbox name="Is_Work" v-model="header.Is_Work" :binary="true" v-if="header"
                                                :disabled="mode != this.$FORM_MODE_CREATE || this.work_disabled"/>
                                            <Skeleton v-else-if="!header" />
                                    </FormField>

                                    <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                            v-model="header.Contractor_Code" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/contractor_code'"
                                            :minLength="0"
                                            :params="{ docDate: (this.header.Created_Date != null ? this.header.Created_Date  : null)}" 
                                            @change="onChange();onChangeContractor($event)"
                                            :disabled="mode != this.$FORM_MODE_CREATE || disabledContractor"/>
                                            <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                        </small>
                                    </FormField>

                                    <!-- <div class="field grid">
                                        <label for="No_Wo" class="col-4">{{ $t('no_wo') }}</label>
                                        <div class="col-6 md-6">
                                            <InputText name="Code" v-model="header.No_Wo" type="text" :placeholder="$t('no_wo')"
                                                v-if="header" @change="onChange()"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.is_notedit"/>
                                            <Skeleton v-else-if="!header" />
                                            <small v-if="header && !header.No_Wo && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('no_wo')) }}
                                            </small>
                                        </div>
                                    </div> -->

                                    <FormField :labelName="$t('no_wo')" fieldName="No_Wo" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="No_Wo" :filter="true"  v-if="header"
                                            v-model="header.No_Wo" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/main_data_wo'"
                                            :minLength="0"
                                            :params="{}" 
                                            :disabled="mode != this.$FORM_MODE_CREATE || header.is_notedit" @change="onChangeWorkNumber"/>
                                            <small v-if="header && !header.No_Wo && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('no_wo')) }}
                                            </small>
                                    </FormField>

                                    <FormField :labelName="$t('job_desc')" fieldName="Deskripsi_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <Textarea name="Deskripsi_Pekerjaan" v-model="header.Deskripsi_Pekerjaan" required="true" type="text"
                                            :placeholder="$t('job_desc')" v-if="header" @change="onChange()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.is_notedit || disabledDeskripsiPekerjaan" />
                                            <small v-if="header && !header.Deskripsi_Pekerjaan && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('job_desc')) }}
                                            </small>
                                    </FormField>

                                    <FormField :labelName="$t('area')" fieldName="Company_Area_Id" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect name="Company_Area_Id" :filter="true"  v-if="header"
                                            v-model="header.Company_Area_Id" required="true" 
                                            placeholder="Please Select"
                                            :url="$API_URL + 'list/area_id'"
                                            :minLength="0"
                                            :params="{ docDate: (this.header.Created_Date != null ? this.header.Created_Date  : new Date())}" 
                                            @change="onChange();onChangeArea($event)"
                                            :disabled="mode != this.$FORM_MODE_CREATE || disabledCompanyArea"/>
                                            <small v-if="header && !header.Company_Area_Id && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('area')) }}
                                        </small>
                                    </FormField>

                                    <!-- <FormField :labelName="$t('no_spr')" fieldName="No_SPR" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputText name="No_SPR" v-model="header.No_SPR" required="true" type="text"
                                            :placeholder="$t('no_spr')" v-if="header" @keypress="onlyNumber" @change="onChange()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || disabledNoSPR" maxlength="10"/>
                                            <small v-if="header &&((!header.No_SPR && !header.Is_Urgent) ||  (header.is_notedit && !header.No_SPR)) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('no_spr')) }}
                                            </small>
                                    </FormField> -->

                                    <div class="field grid">
                                        <label for="Period From" class="col-4">{{$t('no_spr')}}</label>
                                        <div class="col-3 md-3">
                                            <InputText name="No_SPR" v-model="header.No_SPR" required="true" type="text"
                                            :placeholder="$t('no_spr')" v-if="header" @keypress="onlyNumber" @change="onChange()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || disabledNoSPR" maxlength="10"/>
                                            <small v-if="header &&((!header.No_SPR && !header.Is_Urgent) ||  (header.is_notedit && !header.No_SPR)) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('no_spr')) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>

                                        <label for="Item_SPR" class="col-1">/</label>
                                            <div class="col-2 md-2">
                                                <InputText name="Item" v-model="header.Item_SPR" required="true" type="text"
                                                :placeholder="$t('Item_SPR')" v-if="header"  @keypress="onlyNumber"
                                                :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || disabledItemSPR" maxlength="2"/>
                                                <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>

                                    <!-- <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                            :placeholder="$t('no_spo')" v-if="header"  @keypress="onlyNumber" @change="onChange()"
                                            :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT)" maxlength="10"/>
                                            <small v-if="header && ((!header.No_SPO && !header.Is_Urgent) ||  (header.is_notedit && !header.No_SPO)) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                            </small>
                                    </FormField> -->

                                    <div class="field grid">
                                        <label for="Period From" class="col-4">{{$t('no_spo')}}</label>
                                                <div class="col-3 md-3">
                                                    <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                                    :placeholder="$t('no_spo')" v-if="header"  @keypress="onlyNumber" @change="onChange()"
                                                    :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || disabledNoSPO" maxlength="10"/>
                                                    <small v-if="header && ((!header.No_SPO && !header.Is_Urgent) ||  (header.is_notedit && !header.No_SPO)) && submitted && mode != this.$FORM_MODE_DELETE"
                                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                                    </small>
                                                    <Skeleton v-else-if="!header" />
                                                </div>
                                        <label for="Item" class="col-1">/</label>
                                            <div class="col-2 md-2">
                                                <InputText name="Item" v-model="header.Item" required="true" type="text"
                                                :placeholder="$t('id')" v-if="header"  @keypress="onlyNumber" @change="onChange()"
                                                :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || disabledItem" maxlength="2"/>
                                                <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>


                                    <FormField :labelName="$t('no_spk')" fieldName="No_SPK" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputText name="No_SPK" v-model="header.No_SPK" required="true" type="text"
                                            :placeholder="$t('no_spk')" v-if="header" @change="onChange()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || disabledNoSPK" />
                                            <!-- <small v-if="header && ((!header.No_SPK && !header.Is_Urgent) || (header.is_notedit && !header.No_SPK)) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('no_spk')) }}
                                            </small> -->
                                    </FormField>

                                    <FormField :labelName="$t('contract_value')" fieldName="Nilai_Kontrak" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputNumber name="Nilai_Kontrak" v-model="header.Nilai_Kontrak" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"
                                            :placeholder="$t('contract_value')" v-if="header" @change="onChange()" @input="onChange()"
                                            :disabled="true" />
                                            <small v-if="header && ((!header.Nilai_Kontrak && !header.Is_Urgent) || (header.is_notedit && !header.Nilai_Kontrak)) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('contract_value')) }}
                                            </small>
                                    </FormField>

                                    <FormField :labelName="$t('budget')" fieldName="Budget" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputText name="Budget" v-model="header.Budget" type="text"
                                            :placeholder="$t('budget')" v-if="header" @change="onChange()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.is_notedit || disabledBudget || (header && header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)" />
                                            <small v-if="header && !header.Budget && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('budget')) }}
                                            </small>
                                    </FormField>

                                    <FormField :labelName="$t('nilai_estimasi')" fieldName="Nilai_Estimasi" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputNumber name="Nilai_Estimasi" v-model="header.Nilai_Estimasi" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"
                                            :placeholder="$t('nilai_estimasi')" v-if="header" @change="onChange()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || !this.header.Is_Urgent || (header && header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)" />
                                            <small v-if="header && (!header.Nilai_Estimasi && header.Is_Urgent) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('nilai_estimasi')) }}
                                            </small>
                                    </FormField>

                                    <FormField :labelName="$t('tgl_spo')" fieldName="Tanggal_Mulai" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <DatePicker name="tanggal_mulai" v-model="header.Tanggal_Mulai" type="text"
                                        :placeholder="$t('tgl_spo')" v-if="header" dateFormat="dd/mm/yyyy"
                                        inputMask="99/99/9999" momentFormat="DD/MM/YYYY" @change="onChange()"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || disabledTanggalMulai"/>
                                        <!-- @date-select="onSelectTanggalMulai()" -->
                                        <small
                                            v-if="header && ((!header.Tanggal_Mulai && !header.Is_Urgent) || (header.is_notedit && !header.Tanggal_Mulai)) && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('tgl_spo')) }}
                                        </small>
                                    </FormField>

                                    <FormField :labelName="$t('completion_time')" fieldName="Waktu_Penyelesaian" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <!-- <DatePicker name="Tanggal_Selesai" v-model="header.Tanggal_Selesai" type="text"
                                        :placeholder="$t('completion_time')" v-if="header" dateFormat="dd/mm/yyyy"
                                        inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" @date-select="onSelectTanggalSelesai()"/> -->

                                        <InputNumber  name="Tanggal_Selesai" v-model="header.Waktu_Penyelesaian" @change="onChange()" @input="onChange()"
                                        :placeholder="$t('completion_time')" v-if="header" :useGrouping="false" :min="0"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.is_notedit || disabledWaktuPenyelesaian" />

                                        <small
                                            v-if="header && !header.Waktu_Penyelesaian && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('completion_time')) }}
                                        </small>
                                    </FormField>

                                    <!-- <FormField :labelName="$t('Job_Start_Date')" fieldName="Job_Start_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <DatePicker name="Job_Start_Date" v-model="header.Job_Start_Date" type="text"
                                        :placeholder="$t('Job_Start_Date')" v-if="header" dateFormat="dd/mm/yyyy"
                                        inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT ||(disabledJobStartDate) "/>
                                        <small
                                            v-if="header && !header.Job_Start_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Job_Start_Date')) }}
                                        </small>
                                    </FormField> -->

                                    <FormField :labelName="$t('Currency')" fieldName="Currency" v-model="header" labelClass="col-4" fieldClass="col-6">
                                            <CustomSelect  v-if="header" name="Currency" 
                                                    v-model="header.Currency_Code"  
                                                    :url="$API_URL + 'list/lookup'"
                                                    :params="{ group: $LOOKUP_GROUP.CURRENCY }" 
                                                    :minLength="0" 
                                                    :filter="true"
                                                    :placeholder="$t('Currency')"
                                                    :disabled="mode != this.$FORM_MODE_CREATE || (header && header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) || this.disableCurrency"/>
                                        <small v-if="header && !header.Currency_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('Currency')) }}
                                            </small>
                                    </FormField>
                                    <FormField :labelName="$t('Total_Contract_Amount_SAP')" fieldName="Total_Contract_Amount_SAP" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputNumber name="Total_Contract_Amount_SAP" v-model="header.Total_Contract_Amount_SAP" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"
                                            :placeholder="$t('Total_Contract_Amount_SAP')" v-if="header"
                                            :disabled="true" />
                                    </FormField>
                                    <FormField :labelName="$t('Total_Contract_Amount_BoQ')" fieldName="Total_Contract_Amount_BoQ" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <InputNumber name="Total_Contract_Amount_BoQ" v-model="header.Total_Contract_Amount_BoQ" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"
                                            :placeholder="$t('Total_Contract_Amount_BoQ')" v-if="header"
                                            :disabled="true" />
                                    </FormField>

                                    <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="mode == this.$FORM_MODE_EDIT">
                                        <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                            :placeholder="$t('reason')" v-if="header"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| (header.Status != this.$APPROVAL_STATUS.FULL_APPROVAL && header.Status != null)"/>
                                            <small v-if="header &&((!header.Reason && (header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL || header.Status == null))) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                            </small>
                                    </FormField>

                            </div>  

                                <div class="col-6">
                                    <Card>
                                        <template #title><span style="font-size: 15px;">PIC Approver</span></template>
                                        <template #content>
                                            <FormField :labelName="$t('Usrnm_PM')" fieldName="Usrnm_PM" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_PM" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_PM" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.PROJECT_MANAGER, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <!-- <small v-if="header && !header.Usrnm_PM && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('pic_pm')) }}
                                                </small> -->
                                            </FormField>

                                            <FormField :labelName="$t('Usrnm_Prj_Coordinator')" fieldName="Usrnm_Prj_Coordinator" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Prj_Coordinator" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Prj_Coordinator" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.PROJECT_COORDINATOR, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <!-- <small v-if="header && !header.Usrnm_PM_Contractor && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('pic_cp')) }}
                                                </small> -->
                                            </FormField>

                                            <FormField :labelName="$t('Usrnm_Head_Unit')" fieldName="Usrnm_Head_Unit" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Head_Unit" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Head_Unit" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.HEAD_UNIT, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <!-- <small v-if="header && !header.Usrnm_Head_Unit && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('head_unit')) }}
                                                </small> -->
                                            </FormField>

                                            <FormField :labelName="$t('Usrnm_Site_Manager')" fieldName="Usrnm_Site_Manager" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Site_Manager" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Site_Manager" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.SITE_MANAGER, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <!-- <small v-if="header && !header.Usrnm_PM && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('pic_pm')) }}
                                                </small> -->
                                            </FormField>

                                            <FormField :labelName="$t('Usrnm_Qc_Head')" fieldName="Usrnm_Qc_Head" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Qc_Head" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Qc_Head" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.QC_HEAD, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <!-- <small v-if="header && !header.Usrnm_Qc_Head && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('pic_pm')) }}
                                                </small> -->
                                            </FormField>

                                            <FormField :labelName="$t('Usrnm_PM_Contractor')" fieldName="Usrnm_PM_Contractor" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_PM_Contractor" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_PM_Contractor" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameContractor'"
                                                    :params="{ job_postion:this.$UserLevel.PROJECT_MANAGER_CONTRACTOR, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <!-- <small v-if="header && !header.Usrnm_PM_Contractor && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('pic_pm')) }}
                                                </small> -->
                                            </FormField>


                                            <FormField :labelName="$t('Usrnm_Section_Head')" fieldName="Usrnm_Section_Head" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Section_Head" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Section_Head" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.SECTION_HEAD, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <!-- <small v-if="header && !header.Usrnm_PM_Contractor && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('pic_pm')) }}
                                                </small> -->
                                            </FormField>
                                            <FormField :labelName="$t('Usrnm_Quantity_Surveyor')" fieldName="Usrnm_Quantity_Surveyor" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Quantity_Surveyor" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Quantity_Surveyor" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.QUANTITY_SURVEYOR, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            </FormField>
                                            <FormField :labelName="$t('Usrnm_QS_Contractor')" fieldName="Usrnm_QS_Contractor" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_QS_Contractor" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_QS_Contractor" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameContractor'"
                                                    :params="{ job_postion:this.$UserLevel.QS_CONTRACTOR, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            </FormField>
                                            <FormField :labelName="$t('Usrnm_Admin_Project')" fieldName="Usrnm_Admin_Project" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Admin_Project" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Admin_Project" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                    :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.ADMIN_PROJECT, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            </FormField>
                                            <FormField :labelName="$t('Usrnm_Factory_Manager')" fieldName="Usrnm_Factory_Manager" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Factory_Manager" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Factory_Manager" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                     :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.FACTORY_MANAGER, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            </FormField>
                                            <FormField :labelName="$t('Usrnm_Operation_Head')" fieldName="Usrnm_Operation_Head" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Operation_Head" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Operation_Head" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                     :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.OPERATION_HEAD, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            </FormField>
                                            <FormField :labelName="$t('Usrnm_Site_PIC')" fieldName="Usrnm_Site_PIC" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Site_PIC" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Site_PIC" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                     :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.SITE_PIC, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            </FormField>
                                            <FormField :labelName="$t('Usrnm_Project_Engineer')" fieldName="Usrnm_Project_Engineer" v-model="header" labelClass="col-4" fieldClass="col-7">
                                                <CustomSelect name="Usrnm_Project_Engineer" :filter="true"  v-if="header"
                                                    v-model="header.Usrnm_Project_Engineer" required="true" 
                                                    placeholder="Please Select"
                                                    :minLength="0"
                                                     :url="$API_URL + 'list/usernameWilmar'"
                                                    :params="{ job_postion:this.$UserLevel.PROJECT_ENGINEER, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                            </FormField>
                                            
                                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-7" v-if="mode == this.$FORM_MODE_EDIT">
                                                <InputText name="Reason" v-model="header.ReasonPicAppr" required="true" type="text"
                                                    :placeholder="$t('reason')" v-if="header"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                                    <small v-if="header &&((!header.ReasonPicAppr)) && submitted1 && mode != this.$FORM_MODE_DELETE"
                                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                                    </small>
                                            </FormField>

                                        </template>
                                        <template #footer>
                                            <div style="text-align: right">
                                                <Button icon="pi pi-upload" label="Update PIC" style="width: 120px;" class="p-button-success" @click="confirmPicAppr($event)" v-if="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                                            </div>
                                        </template>
                                    </Card>

                                
                                </div>
                                <div class="col-12">
                                    <TabView>
                                        <TabPanel :header="$t('log_history')">
                                            <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                                :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                        </TabPanel>
                                        <TabPanel :header="$t('release_approval')">
                                            <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                                :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                        </TabPanel>
                                        <TabPanel :header="$t('Change_History')">
                                            <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                        </TabPanel>
                                    </TabView>
                                </div>
                            </div>
                        </div>
                    </template>
                </Card>
            </TabPanel>
            <TabPanel v-if="canViewRKTK" :header="$t('BoQ')">
                 <EditorBoQ :header="header" :isAuth="false" :mode="mode"/>
            </TabPanel>
            <TabPanel :header="$t('Link_Work_Order')" v-if="mode != this.$FORM_MODE_CREATE">
                <EditorLinkWO :header="this.header"/>
            </TabPanel>
        </TabView>
    </form>
</template>


<script>
 import EditorBoQ from './_EditorBOQ.vue';
 import EditorLinkWO from './_EditorLinkWO.vue';
export default {
    name: "Editor",
    components: { EditorBoQ : EditorBoQ
       , EditorLinkWO: EditorLinkWO 
    },
    data() {
        return {
            indexName: "MainDataIndex",
            url: this.$API_URL + "maindata/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            work_disabled : false,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            disabledCompanyArea : false,
            disabledWaktuPenyelesaian : false,
            disabledBudget  : false,
            disabledNoSPR  : false,
            disabledNoSPO  : false,
            disabledNoSPK  : false,
            disabledDeskripsiPekerjaan  : false,
            disabledTanggalMulai  : false,
            disabledItem  : false,
            disabledJobStartDate  : false,
            disableCurrency : false,
            getCompany : null,
            getContractor : null,
            newValComp : null,
            oldValComp : null,
            newValContractor : null,
            oldValContractor : null,
            submitted1 : false,
            ReasonPicAppr : "",
            disabledItemSPR : false,
            disabledContractor : false, 
            workOrderMain: [],
            listTransactionView : [],
            canViewRKTK : false,
        }
    },
    mounted() {
        this.listTransactionView =  this.$store.getters.getListTransactionView;
        this.canViewRKTK = this.listTransactionView.includes('RKTK');
    },
    methods: {
        onChangeContractor(e){
            if(e){

                this.getContractor = e.text;
            }else{
                this.getContractor = null;
            }

        },
        onChangeArea(e){
            if(e){
                this.header.Company_Code = e.Company_Code;
                this.getCompany = e.Company_Code;
                if(this.newValComp && this.oldValComp && (this.newValComp != this.oldValComp)){
                    this.header.Usrnm_PM = null;
                    this.header.Usrnm_Head_Unit = null;
                    this.header.Usrnm_PM_Contractor = null;
                    this.header.Usrnm_Site_Manager = null;
                    this.header.Usrnm_Qc_Head = null;
                    this.header.Usrnm_Prj_Coordinator = null;
                }
            }else{
                this.header.Company_Code = null;
                this.header.Usrnm_PM = null;
                this.header.Usrnm_Head_Unit = null;
                this.header.Usrnm_PM_Contractor = null;
                this.header.Usrnm_Site_Manager = null;
                this.header.Usrnm_Qc_Head = null;
                this.header.Usrnm_Prj_Coordinator = null;
                this.getCompany = null;
            }
        },
        onChangeWorkNumber(e){
            if(e){
                this.header.Company_Area_Id = e.Company_Area_Id;
                this.header.Waktu_Penyelesaian = e.Duration;
                this.header.Budget = e.WBS_Allocation;
                this.header.No_SPR = e.No_SPR;
                this.header.No_SPO = e.No_SPO;
                this.header.No_SPK = e.No_SPK;
                this.header.Deskripsi_Pekerjaan = e.Work_Description;
                this.header.Tanggal_Mulai = e.SPO_Date;
                this.header.Item = e.Item;
                this.header.Item_SPR = e.Item_SPR;
                this.header.Job_Start_Date = e.Job_Start_Date;
                this.header.Company_Code = e.Company_Code;
                this.getCompany = e.Company_Code;
                this.header.Contractor_Code = e.Contractor_Code;
                this.header.Nilai_Kontrak = e.Contract_Value;
                this.header.Currency_Code = e.Currency;
                this.header.Is_Additional = e.Is_Additional;
                this.header.CanIputScope = e.canInputScope;
                this.header.Location_Code = e.Location_Code;
                
                if(this.header.Is_Additional)
                {
                    this.$axios.get(this.url + "getBoQAddendum/" + e.wo_id)
                    .then((response) => {

                        if(!response.data.success){
                            self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                            return;
                        }
                        this.header.BoQ_MAIN = response.data.data.header.BoQ_MAIN;
                        
                    })
                    .catch(function (error) {
                        self.showError("Error", error);
                    });
                }else{
                    this.header.Is_Additional = false;
                    this.header.BoQ_MAIN = null;

                }

                // this.header.Currency = e.Currency;

                //assign is disabled
                this.disabledCompanyArea = this.header.Company_Area_Id ? true:true;
                this.disabledWaktuPenyelesaian= this.header.Waktu_Penyelesaian ? true:true;
                this.disabledBudget = this.header.Budget ? true:true;
                this.disabledNoSPR = this.header.No_SPR ? true:true;
                this.disabledNoSPO  = this.header.No_SPO ? true:true;
                this.disabledSPODate = this.header.SPO_Date ? true:true;
                this.disabledNoSPK= this.header.No_SPK ? true:true;
                this.disabledDeskripsiPekerjaan = this.header.Deskripsi_Pekerjaan ? true:true;
                this.disabledTanggalMulai  = this.header.Tanggal_Mulai ? true:true;
                this.disabledItem = this.header.Item ? true:true;
                this.disabledItemSPR = this.header.Item_SPR ? true:true;
                this.disabledJobStartDate = this.header.Job_Start_Date ? true:true;
                this.disabledContractor = this.header.Contractor_Code != null ? true:false;
                this.disableCurrency = this.header.Currency_Code != null ? true:false;
                
                
            }else{
                this.header.Company_Area_Id = null;
                this.header.Waktu_Penyelesaian =null;
                this.header.Budget = null;
                this.header.No_SPR = null;
                this.header.No_SPO = null;
                this.header.SPO_Date = null;
                this.header.No_SPK = null;
                this.header.Deskripsi_Pekerjaan = null;
                this.header.Tanggal_Mulai = null;
                this.header.Item = null;
                this.header.Job_Start_Date = null;
                this.header.Company_Code = null;
                this.header.Contractor_Code = null;
                this.header.Currency_Code = null;
                this.header.Contract_Value = null;
                this.header.Is_Additional = false;
                this.header.BoQ_MAIN = null;

                //assign is disabled
                this.disabledCompanyArea = false;
                this.disabledWaktuPenyelesaian= false;
                this.disabledBudget = false;
                this.disabledNoSPR =false;
                this.disabledNoSPO  =false;
                this.disabledSPODate = false;
                this.disabledNoSPK= false;
                this.disabledDeskripsiPekerjaan = false;
                this.disabledTanggalMulai  = false;
                this.disabledItem = false;
                this.disabledItemSPR = false;
                this.disabledJobStartDate = false;
                this.disabledContractor = false;

                this.header.Usrnm_PM = null;
                this.header.Usrnm_Head_Unit = null;
                this.header.Usrnm_PM_Contractor = null;
                this.header.Usrnm_Site_Manager = null;
                this.header.Usrnm_Qc_Head = null;
                this.header.Usrnm_Prj_Coordinator = null;
                this.getCompany = null;
            }
        },
        onChange(){
            this.header.Is_Change = true;
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },
        onSelectTanggalMulai(){
            if(this.header.Tanggal_Selesai){
                if(new Date(this.header.Tanggal_Mulai) > new Date(this.header.Tanggal_Selesai)){
                    this.showError("Error", "Tanggal Mulai greater than Tanggal Selesai");
                    this.header.Tanggal_Mulai= null;
                }
            }
        },
        onSelectTanggalSelesai(){
            if(this.header.Tanggal_Mulai){
                if(new Date(this.header.Tanggal_Selesai) < new Date(this.header.Tanggal_Mulai)){
                    this.showError("Error", "Tanggal Selesai smaller than Tanggal Mulai");
                    this.header.Tanggal_Selesai= null;
                }
            }
        },
        onClickIsUrgent(){
            if(this.header.Is_Urgent){
                this.header.No_SPO = null;
                this.header.Item = null;
                this.header.No_SPK = null;
                this.header.Nilai_Kontrak = null;
                this.work_disabled = true;
                this.header.Is_Work = true;
            }else{
                this.header.Nilai_Estimasi = null;
                this.work_disabled = false;
                this.header.Is_Work = false;
            }
                
        },
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detailLog = self.header.DetailLog;
                    self.workOrderMain = response.data.data.WorkOrderModels;
                    self.header.CanIputScope = !self.header.Is_Additional ? true : false;
                    
                    
                    if(this.mode != this.$FORM_MODE_CREATE){
                        this.header.ReasonPicAppr = this.ReasonPicAppr;

                        self.disabledCompanyArea = self.header.Company_Area_Id ? true:true;
                        self.disabledWaktuPenyelesaian= self.header.Waktu_Penyelesaian ? true:true;
                        self.disabledBudget = self.header.Budget ? true:true;
                        self.disabledNoSPR = self.header.No_SPR ? true:true;
                        self.disabledNoSPO  = self.header.No_SPO ? true:true;
                        self.disabledSPODate = self.header.SPO_Date ? true:true;
                        self.disabledNoSPK= self.header.No_SPK ? true:true;
                        self.disabledDeskripsiPekerjaan = this.header.Deskripsi_Pekerjaan ? true:true;
                        self.disabledJobStartDate =  this.header.Job_Start_Date ? true:true;
                        self.disabledTanggalMulai  = self.header.Tanggal_Mulai ? true:true;
                        self.disabledItem = self.header.Item ? true:true;
                        self.disabledItemSPR = self.header.Item_SPR ? true : true;
                    }
                    

                    if(self.header.Logo_Contractor){
                            var attachment = this.header.Logo_Contractor.split(';');
                            self.viewFiles = [];
                            attachment.forEach(a => {
                                if (a != '') {
                                    var name = a.split("/").at(-1);
                                    var d = {
                                        name: name,
                                        // url: a,
                                        id: self.header.Id
                                    };

                                    self.viewFiles.push(d);
                                }
                            });
                        }
                })
                .catch(function (error) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: error.message || error, life: 5000 });
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            // var data = new FormData();
                
            //     if(this.header.files_data != null)
            //         for(var x=0; x < this.header.files_data.length;x++){
            //             var file = this.header.files_data[x];
            //             data.append("attachments.File", file, file.name);
            //     }
            //     data.append("Code", this.header.Code);
            //     data.append("Id", this.header.Id);
            //     data.append("Company_Name", this.header.Company_Name);
            //     data.append("Service_Type", this.header.Service_Type);
            //     data.append("Adress", this.header.Adress);
            //     data.append("mode", this.header.mode);
              
             this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Main Data has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Main Data has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    const errorMsg = error.isTimeout ? error.message : (error.message || error);
                    self.showError('Error Saving Data', errorMsg);
                })
                .finally(() => {
                    self.$emit('unblock-ui');
                });
        },
        showError(summary, message) {
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 5000 });
        },
        backToIndex() {
            this.$router.push({ path: "/MainData/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            //|| !this.header.Budget || ((!this.header.No_SPK && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.No_SPK)) 

            if(this.mode != this.$FORM_MODE_DELETE){
                    if ( !this.header.Contractor_Code || !this.header.No_Wo || !this.header.Deskripsi_Pekerjaan || !this.header.Company_Area_Id  || !this.header.Budget || 
                    ((!this.header.No_SPR && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.No_SPR)) || ((!this.header.Nilai_Kontrak && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.Nilai_Kontrak)) || (!this.header.Currency_Code) || 
                    (!this.header.Nilai_Estimasi && this.header.Is_Urgent) || ((!this.header.Tanggal_Mulai && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.Tanggal_Mulai)) || !this.header.Waktu_Penyelesaian || ((!this.header.No_SPO && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.No_SPO))
                    || (!this.header.Reason && (this.header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL || (this.header.Status == null && this.mode == this.$FORM_MODE_EDIT)))
                    ) {
                    return;
                }
            
                // if(this.header.No_SPR != null){
                //     if(this.header.No_SPR.length < 10 && this.header.No_SPR.length != 0){
                //         this.showError('Error Saving Data', "The length of the SPR number is less than 10");
                //         return false;
                //     }
                // }

            
                // if(this.header.No_SPO != null){
                //     if(this.header.No_SPO.length < 10 && this.header.No_SPO.length != 0){
                //         this.showError('Error Saving Data', "The length of the SPO number is less than 10");
                //         return false;
                //     }
                // }
            
                // if(this.header.Item != null){
                //     if(this.header.Item.length < 2 && this.header.Item.length != 0){
                //         this.showError('Error Saving Data', "The length of the Item number is less than 1");
                //         return false;
                //     }
                // }

            }

            
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmPicAppr(event) {
            this.submitted1 = true;
        
            if(this.mode != this.$FORM_MODE_DELETE){
                    if (!this.header.ReasonPicAppr) {
                    return;
                }
            }
            
            this.ReasonPicAppr = this.header.ReasonPicAppr;
            
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveDataPicAppr();
                },
                reject: () => {

                }
            });
            
        },
        saveDataPicAppr() {
            this.$emit('block-ui');
            var self = this;
              
             this.$axios.post(this.url+"saveAppr", this.header)
                .then((response) => {
                    if (response.data.success) {
                        self.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
                        
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                    self.getData();
                })
                .catch(function (error) {
                    const errorMsg = error.isTimeout ? error.message : (error.message || error);
                    self.showError('Error Saving Data', errorMsg);
                })
                .finally(() => {
                    self.$emit('unblock-ui');
                });
        },
        confirmDraft(event) {
            this.submitted = true;
            //!this.header.Budget || ((!this.header.No_SPK && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.No_SPK))
            if ( !this.header.Contractor_Code || !this.header.No_Wo || !this.header.Deskripsi_Pekerjaan || !this.header.Company_Area_Id  || !this.header.Budget || 
                (!this.header.No_SPR && !this.header.Is_Urgent) || ((!this.header.Nilai_Kontrak && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.Nilai_Kontrak)) || 
                (!this.header.Nilai_Estimasi && this.header.Is_Urgent) ||((!this.header.Tanggal_Mulai && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.Tanggal_Mulai)) || !this.header.Waktu_Penyelesaian || ((!this.header.No_SPO && !this.header.Is_Urgent) || (this.header.is_notedit && !this.header.No_SPO))) {
                return;
            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                            this.header.mode = this.$FORM_MODE_EDIT_DRAFT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },


        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    },
    watch:{
        getCompany(newVal, oldVal){
            this.newValComp = newVal;
            this.oldValComp = oldVal;
            if(this.newValComp && this.oldValComp && (this.newValComp != this.oldValComp))
            {
                this.header.Usrnm_PM = null;
                this.header.Usrnm_Head_Unit = null;
                this.header.Usrnm_Site_Manager = null;
                this.header.Usrnm_Qc_Head = null;
                this.header.Usrnm_Prj_Coordinator = null;
            }

        },
        getContractor(newVal, oldVal){
            this.newValContractor = newVal;
            this.oldValContractor = oldVal;
            if(this.newValContractor && this.oldValContractor && (this.newValContractor != this.oldValContractor))
            {
                this.header.Usrnm_PM_Contractor = null;        
            }
        }
        
    }
}
</script>
<style>
.custom-tabview .p-tabview-nav {
  border-bottom: 2px solid #ccc; 
  font-size: 1.2rem; 
  font-weight: 600;
}

.custom-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background-color: #007ad9 !important; 
  color: white !important;
  border-radius: 4px 4px 0 0;
}

.custom-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 0.75rem 1rem;
  border: 1px solid #ccc;
  border-bottom: none;
}

.tab-content-placeholder {
  min-height: 150px; 
  border: 1px solid #ccc;
  border-top: none;
  padding: 1rem;
  background-color: #fafafa;
}
.fixed-table .p-datatable-table {
  table-layout: fixed !important;
  width: 100%;
}
</style>